import React from 'react';
import LoginForm from '../../components/forms/LoginForm/LoginForm';

const Login = ({ onLogin }) => {
    return (
        <div className="login-page">
            <LoginForm onLogin={onLogin} />
        </div>
    );
};

export default Login;
